var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDfcLogo200Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6309 41.5205V158.48H104.694C125.778 158.48 158.479 141.28 158.479 100C158.479 58.7205 125.348 41.5205 104.694 41.5205H52.6309ZM69.5899 60.234V139.766H104.97C119.298 139.766 141.52 128.07 141.52 100C141.52 71.9299 119.005 60.234 104.97 60.234H69.5899Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9708 32.7485V18.6288C26.374 34.4875 7.01758 64.9831 7.01758 100C7.01758 135.017 26.374 165.512 54.9708 181.371V167.251H43.8597V145.902C33.6257 133.399 27.4854 117.417 27.4854 100C27.4854 82.5831 33.6257 66.6006 43.8597 54.0985V32.7485H54.9708Z",
    fill: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.176 169.671V190.788C161.828 181.573 192.983 144.425 192.983 100C192.983 55.5754 161.828 18.4274 120.176 9.2124V30.329C150.408 39.0682 172.515 66.9526 172.515 100C172.515 133.047 150.408 160.932 120.176 169.671Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6309 154.907C54.0763 156.155 55.5715 157.347 57.1131 158.48H52.6309V154.907Z",
    fill: "#EDEDED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1131 41.5205C55.5715 42.653 54.0763 43.845 52.6309 45.0931V41.5206L57.1131 41.5205Z",
    fill: "#EDEDED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7422 32.4561H80.4089V0L63.7422 12.2807V32.4561Z",
    fill: "#EDEDED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7422 167.251H80.4089V199.708L63.7422 187.427V167.251Z",
    fill: "#EDEDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7363 32.4561H111.403V0L94.7363 12.2807V32.4561Z",
    fill: "#EDEDED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7363 167.251H111.403V199.708L94.7363 187.427V167.251Z",
    fill: "#EDEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfcLogo200Px);
export default __webpack_public_path__ + "static/media/DFCLogo200px.f63ee241a3d4dc70b205653ab18503c3.svg";
export { ForwardRef as ReactComponent };